import { BaseModel } from '../base-model';
import { Moment } from 'moment';
export interface IAppointmentParameterModel {
  startDate?: Moment;
  toDate?: Moment;
  UserIds?: string;
  cache?: boolean;
    SaveUserIds?: boolean;
    IgnoreAgendaSharing?: boolean;

    // DistanceMinutes?:number;
}

export class AppointmentParameterModel extends BaseModel<IAppointmentParameterModel> implements IAppointmentParameterModel {
  from: string;
  to: string;
  UserIds: string;
    cache?: boolean;
    SaveUserIds: boolean = true;
    // FRO-11241: query the requested UserIds as-is instead of stripping users
    // whose agenda-sharing settings exclude the viewer (enquiry webview only)
    IgnoreAgendaSharing?: boolean;
    // DistanceMinutes:number = 100;
  /**
   *
   */
  constructor(options?: { [key: string]: any }) {
    super(options);
  }
}

